"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const flatPages_1 = __importDefault(require("./flatPages"));
const flatSideMenu_1 = __importDefault(require("./flatSideMenu"));
const flatBuildOrdersControls = (buildOrders) => {
    let flatted = {};
    if (buildOrders.pages) {
        flatted = (0, flatPages_1.default)({ pages: buildOrders.pages });
    }
    if (buildOrders.menus && buildOrders.menus.sideMenu) {
        flatted = (0, flatSideMenu_1.default)({
            sideMenu: buildOrders.menus.sideMenu,
            initialObject: flatted,
        });
    }
    return flatted;
};
exports.default = flatBuildOrdersControls;
